import TextField from "../../../../components/fields/textField/TextField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../../components/fields/file-input-field/FileInputField.vue";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import moment from "moment";
import { AgendarFeriasService } from "../../../../services/AgendarFeriasService.js";
import { FeriasService } from "../../../../services/FeriasService";
import { SolicitarFeriasService } from "../../../../services/SolicitarFeriasService";


import {
  TIPO_ALTERACAO,
  TIPO_ALTERACAO_INTERRUPCAO,
  TIPO_ALTERACAO_PRORROGACAO,
  tipoAlteracaoEnum
} from "../../../../constants";

export default {
  name: "ProrrogarInterromperFerias",

  props: {
    options: {
      type: Array,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField
  },

  beforeMount() {
    this.initializeForm();
  },

 
  data: () => ({
    unidadeLotacao:null,
    dataParcela: [],
    exercicio:null,
    militar: null,
    parcela: null,
    subtituloExercicio: "Por favor selecione um exercício",
    form: {},
    loading: {
      field: false,
      btn: false,
    }
  }),

  computed: {
    enumTipoAlteracao() {
      return tipoAlteracaoEnum;
    }
  },

  mounted() {
    this.options.tipoAlteracao = TIPO_ALTERACAO.slice(0,2);
    this.options.prorrogacao = TIPO_ALTERACAO_PRORROGACAO;
    this.options.interrupcao = TIPO_ALTERACAO_INTERRUPCAO;
  },



  disabled: false,

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.initializeForm();
      }
    },
    unidadeLotacao: async function(unidade_id){
      if(unidade_id == ""){
        SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
        return;
      }
      await this.pegarPessoasPorUnidadeComFerias(unidade_id);
      this.$forceUpdate()
    },
    militar: async function(pessoa_id){
      if(pessoa_id == ""){
        SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
        return;
      }
       this.pegarGraduacaoPorPessoa(pessoa_id);
      await this.pegarExercicioPorPessoa(pessoa_id);
      this.$forceUpdate()
    },
    "form.exercicio": async function(exercicio){
      if(exercicio == ""){
        SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
        return;
      }
      this.pegarDiasPendentesDaPessoa(exercicio,this.militar);
      await this.pegarParcelasDaPessoa(exercicio, this.militar);
      this.$forceUpdate()
    },
    parcela: function(parcela){
      if(parcela == ""){
        SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
        return;
      }
      this.form.dataInicio = this.dataParcela[parcela].dataIni
      this.form.dataFim = this.dataParcela[parcela].dataFim
      this.form.idFerias = this.dataParcela[parcela].idFerias
    }
  },

  methods: {
 


    initializeForm() {

      this.options.tipoAlteracao = TIPO_ALTERACAO.slice(0,2);
      this.options.prorrogacao = TIPO_ALTERACAO_PRORROGACAO;
      this.options.interrupcao = TIPO_ALTERACAO_INTERRUPCAO;
      this.options.parcelas = []

      this.form = {
        idFerias: null,    
        dataInicio: null,
        dataFim: null,
        exercicio: null,

        dataInicioAltInt: null,
        dataFimAltInt:    null,
        numeroDiasAltInt: null,
    
        prorrogacao: null,
        interrupcao: null,
        alterarPeriodo: null,
        tipoAlteracao:null,
        anexo: null

      }
    },

    async calculateDaysAltInt() {
      if (this.form.dataInicioAltInt != null) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataInicioAltInt).format("YYYY-MM-DD"));
        formData.append("dias", this.form.numeroDiasAltInt);
        const response = await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form.dataFimAltInt = response.dataFim;
        this.form.numeroDiasAltInt = response.dias_uteis;
        return;
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    async pegarPessoasPorUnidadeComFerias(unidade_id){
      const response = await AgendarFeriasService.pegarPessoasPorUnidadeComFerias(unidade_id);
      this.options.militares =  response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });


      this.options.militares?.unshift({ text: "Selecione", value: "" })

      return this.options.militares;
    },
    async pegarGraduacaoPorPessoa(pessoa_id){
      const response = await AgendarFeriasService.pegarGraduacaoPorPessoa(pessoa_id);
      this.options.postoGraduacao = response[0].graduacao
      return;
    },
    async pegarDiasPendentesDaPessoa(exercicio,pessoa_id){
      const response = await AgendarFeriasService.pegarDiasPendentesDaPessoa(exercicio,pessoa_id);
      this.form.numeroDias = response

      this.subtituloExercicio = `Você possui um saldo de ${response.dias} dia(s) no exercício ${exercicio}`

      return;
    },

    async pegarParcelasDaPessoa(exercicio,pessoa_id){
      console.log(exercicio);
      const response = await AgendarFeriasService.pegarParcelasDaPessoa(exercicio,pessoa_id);
 
      this.options.parcelas = response.map(el => {
        this.dataParcela[el.parcela] = {'dataIni': el.data_ini, 'dataFim': el.data_fin, 'idFerias': el.id};
        return {
          text: el.parcela,
          value: el.parcela,
        }
      });

      this.options.parcelas?.unshift({ text: "Selecione", value: "" })


      return;
    },

    async pegarExercicioPorPessoa(pessoa_id){
      const response = await FeriasService.getExercicioEmFeriasCadaMilitar(pessoa_id);
      this.options.exercicio = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.options.exercicio?.unshift({ text: "Selecione", value: "" })

    },


    prepareform() {
      if (this.$refs.form.validate()) {

        const formData = new FormData();
        formData.append("id_tipo_alteracao_alterar_periodo", this.form.tipoAlteracao);
        formData.append("data_inicio", moment(this.form.dataInicioAltInt).format("YYYY-MM-DD"));
        formData.append("data_fim", moment(this.form.dataFimAltInt).format("YYYY-MM-DD"));
        formData.append("dias", this.form.numeroDiasAltInt);        
        formData.append("arquivo", this.form.anexo);



        formData.append("id_ferias", this.form.idFerias);

        
        if (this.form.prorrogacao) {
          this.form.prorrogacao.forEach((el, index) => {
            formData.append(`entidade_tipo_alteracao_json[${index}]`, el);
          });
        }
        if (this.form.interrupcao) {
          this.form.interrupcao.forEach((el, index) => {
            formData.append(`entidade_tipo_alteracao_json[${index}]`, el);
          });
        }

        this.saveform(formData);

        
        return;
      
      }
      SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");

    },

    async saveform(formData) {
      this.loading.btn = true;
      const response = await AgendarFeriasService.interromperFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.close();
      }
    },

    close() {
      this.initializeForm();
      this.$emit("on-close");
    },
  },
};